module.exports = __webpack_public_path__ + "img/compra-legal.ef90764a.jpg";